import axios from 'axios';

class PaymentStatusChecker {
    constructor() {
        this.maxAttempts = 20;
        this.intervalMs = 3000;
        this.currentAttempt = 0;
        this.checkUrl = null;
        this.successUrl = null;
        this.elements = {};
    }

    init(config) {
        this.checkUrl = config.checkUrl;
        this.successUrl = config.successUrl;
        this.failedUrl = config.failedUrl;
        this.bindElements();
        this.startChecking();
    }

    bindElements() {
        this.elements = {
            progressBar: document.getElementById('progress-bar'),
            statusMessage: document.getElementById('status-message'),
            attemptCounter: document.getElementById('attempt-counter'),
            currentAttempt: document.getElementById('current-attempt'),
            timeoutMessage: document.getElementById('timeout-message'),
            spinner: document.querySelector('.spinner-border'),
            progress: document.querySelector('.progress')
        };
    }

    startChecking() {
        setTimeout(() => this.checkStatus(), this.intervalMs);
    }

    checkStatus() {
        this.currentAttempt++;
        this.updateProgress();

        axios.get(this.checkUrl, {
            headers: { 'Accept': 'application/json' }
        })
        .then(response => this.handleResponse(response.data))
        .catch(error => this.handleError(error));
    }

    handleResponse(data) {
        // Pago exitoso
        if (data.is_paid) {
            this.showSuccess();
            return;
        }

        // Pago rechazado/fallido/cancelado - redirigir a página de error
        const failedStatuses = ['failed', 'rejected', 'cancelled', 'expired'];
        if (data.status && failedStatuses.includes(data.status)) {
            this.showFailed();
            return;
        }

        // Límite de intentos alcanzado
        if (this.currentAttempt >= this.maxAttempts) {
            this.showTimeout();
            return;
        }

        // Continuar verificando (pending, in_process, etc.)
        setTimeout(() => this.checkStatus(), this.intervalMs);
    }

    handleError(error) {
        console.error('Error verificando pago:', error);

        if (this.currentAttempt >= this.maxAttempts) {
            this.showTimeout();
            return;
        }

        setTimeout(() => this.checkStatus(), this.intervalMs);
    }

    updateProgress() {
        const progress = (this.currentAttempt / this.maxAttempts) * 100;

        if (this.elements.progressBar) {
            this.elements.progressBar.style.width = progress + '%';
        }

        if (this.elements.currentAttempt) {
            this.elements.currentAttempt.textContent = this.currentAttempt;
        }
    }

    showSuccess() {
        if (this.elements.statusMessage) {
            this.elements.statusMessage.textContent = 'Pago confirmado. Redirigiendo...';
        }

        if (this.elements.progressBar) {
            this.elements.progressBar.classList.remove('progress-bar-animated');
            this.elements.progressBar.classList.add('bg-success');
            this.elements.progressBar.style.width = '100%';
        }

        setTimeout(() => {
            window.location.href = this.successUrl;
        }, 1000);
    }

    showFailed() {
        if (this.elements.statusMessage) {
            this.elements.statusMessage.textContent = 'El pago no fue aprobado. Redirigiendo...';
        }

        if (this.elements.progressBar) {
            this.elements.progressBar.classList.remove('progress-bar-animated');
            this.elements.progressBar.classList.add('bg-danger');
            this.elements.progressBar.style.width = '100%';
        }

        setTimeout(() => {
            window.location.href = this.failedUrl;
        }, 1500);
    }

    showTimeout() {
        this.elements.attemptCounter?.classList.add('d-none');
        this.elements.statusMessage?.classList.add('d-none');
        this.elements.spinner?.classList.add('d-none');
        this.elements.progress?.classList.add('d-none');
        this.elements.timeoutMessage?.classList.remove('d-none');
    }
}

export default new PaymentStatusChecker();
